import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCcFuHl24OGn4eG4xCJY1IvSrBmoRjSViE",
  authDomain: "fbk-storyboard.firebaseapp.com",
  projectId: "fbk-storyboard",
  storageBucket: "fbk-storyboard.firebasestorage.app",
  messagingSenderId: "407319350858",
  appId: "1:407319350858:web:27c7cab6f41f2ddfef20b3",
  measurementId: "G-R7PXM0NRYR",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
